module.exports = __webpack_public_path__ + "/aed48fbef19b3ec6af0ecd7f182b84d1.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/loading-spinner-16.gif
 ** module id = 695
 ** module chunks = 0
 **/